export default "__VITE_ASSET__3B_djgg4__"